import { Node, BackendNode } from 'modules/workflows/types';
import { getNodeTypeFromNode } from './nodeUtils';
import { toPascal } from './toPascal';

type ChangeLogItem = Partial<BackendNode>;
type ChangeLogItems = ReadonlyArray<ChangeLogItem>;
type Changelog = Record<string, ChangeLogItems>;

type ParsedChangelogData = {
  id: string;
  action: string;
  liveWorkflowNodeId: string | unknown;
  nodeType: string | unknown;
};

export const parseChangelogData = (event: Changelog) => {
  const { added, deleted, changed } = event;
  return Object.entries({ added, deleted, changed })?.reduce(
    (act, entry): ParsedChangelogData[] => {
      const [action, actionDetails] = entry;
      const results =
        actionDetails?.map((actionDetail: ChangeLogItem, i: number) => {
          const { liveWorkflowNodeId } = actionDetail;
          const nodeType = getNodeTypeFromNode(actionDetail as unknown as Node);
          return {
            action: toPascal(action),
            id: `${action}-${i}`,
            liveWorkflowNodeId,
            nodeType,
          };
        }) || [];
      return [...act, ...results];
    },
    [] as ParsedChangelogData[],
  );
};
